module.exports = __webpack_public_path__ + "img/transcricao.edc7159f.jpg";